module.exports = __webpack_public_path__ + "img/m.c89b77a9.gif";